'use client';

const APP_NAME = 'frontends-landing-pages';

export default function assetLoader({src}: {src: string}) {
    if (!src.includes('https://')) {
        return `/${APP_NAME}/${src}`;
    }
    if (src.indexOf('/') === 0) {
        return `/${APP_NAME}${src}`;
    }
    return `/${APP_NAME}/${src}`;
}
